import { memo } from 'react';
import styled from 'styled-components';
import VerticalNavSecondaryMenuItem from './VerticalNavSecondaryMenuItem';
import useNavItems from '../../hooks/useNavItems';
import useVerticalNavKeyboardControls from './hooks/useVerticalNavKeyboardControls';
import useIsDevPortal from '../../hooks/useIsDevPortal';
import { MenuItemLevel } from '../../constants';
import { useLinkBadgeData } from './hooks/useLinkBadgeData';
import { jsx as _jsx } from "react/jsx-runtime";
const TertiaryItemContainer = styled.ul.withConfig({
  displayName: "VerticalNavTertiaryMenu__TertiaryItemContainer",
  componentId: "ngzb95-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    padding: `0 0 0 ${theme.space['300']} !important`
  };
});
const TertiaryMenuItem = /*#__PURE__*/memo(item => {
  const navItems = useNavItems();
  const {
    byId,
    activeItem
  } = navItems;
  const {
    onKeyDown
  } = useVerticalNavKeyboardControls();
  const isDevPortal = useIsDevPortal();
  const linkBadgeData = useLinkBadgeData({
    id: item.id,
    navItems
  });
  const {
    path,
    label,
    primaryCategory,
    isBookmarked
  } = byId[item.id];
  const shouldHighlight = activeItem === item.id;
  return /*#__PURE__*/_jsx(VerticalNavSecondaryMenuItem, {
    id: item.id,
    path: path,
    label: label,
    onKeyDown: onKeyDown({
      id: item.id,
      hasParentMenu: true,
      shouldShiftFocusOnOpen: false
    }),
    shouldHighlight: shouldHighlight,
    menuItemLevel: MenuItemLevel.TERTIARY,
    primaryCategory: primaryCategory,
    isBookmarked: !!isBookmarked,
    canBeBookmarked: !isDevPortal,
    isBookmarksMenu: false,
    linkBadgeData: linkBadgeData
  }, item.id);
});
const VerticalNavTertiaryMenu = ({
  tertiaryNavItems
}) => {
  return /*#__PURE__*/_jsx(TertiaryItemContainer, {
    children: tertiaryNavItems.map(tertiaryItem => /*#__PURE__*/_jsx(TertiaryMenuItem, Object.assign({}, tertiaryItem), tertiaryItem.id))
  });
};
export default VerticalNavTertiaryMenu;